import { render } from "./KepIcon.vue?vue&type=template&id=6f387006&scoped=true&ts=true"
import script from "./KepIcon.vue?vue&type=script&lang=ts"
export * from "./KepIcon.vue?vue&type=script&lang=ts"

import "./KepIcon.vue?vue&type=style&index=0&id=6f387006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f387006"]])

export default __exports__